/*
* 確認事項チェックボックス確認
*/

export default class GmoConfirmationCheck {
  constructor() {
    this.$checkBoxes = document.querySelectorAll('[data-target="gmoConfirmCheckBox"]');
  }


  attachEvent() {
    // 全てのチェックボックスの状態が変化したときにtoggleSubmitButton()関数を実行するように設定
    let checkBoxes = Object.values(this.$checkBoxes);
    for (let i = 0; i < checkBoxes.length; i++) {
      checkBoxes[i].addEventListener('change', toggleSubmitButton);
    }

    // 保存ボタンの有効化・無効化
    function toggleSubmitButton() {
      const $checkBoxes = document.querySelectorAll('[data-target="gmoConfirmCheckBox"]');
      const $submitButton = document.querySelector('[data-form="gmoConfirmSubmitButton"]');
      let allChecked = true;

      for (let i = 0; i < $checkBoxes.length; i++) {
        if (!$checkBoxes[i].checked) {
          allChecked = false;
          break;
        }
      }

      if (allChecked) {
        $submitButton.disabled = false;
      } else {
        $submitButton.disabled = true;
      }
    }
  }
}
